// communicationsApi.js - Utskickslogg (Spår L): läs-API för patient_communications

import apiClient from '../../apiClient';

export const getPatientCommunications = async (patientId, params = {}) => {
  const response = await apiClient.get(`/api/patients/${patientId}/communications`, { params });
  return response.data; // { items, total }
};

export const getAppointmentCommunications = async (appointmentId) => {
  const response = await apiClient.get(`/api/appointments/${appointmentId}/communications`);
  return response.data.items || [];
};

export const CHANNEL_LABELS = {
  sms: { label: 'SMS', icon: 'fa-sms' },
  email: { label: 'E-post', icon: 'fa-envelope' },
  letter: { label: 'Brev', icon: 'fa-mail-bulk' },
};

export const CATEGORY_LABELS = {
  kallelse: 'Kallelse',
  booking_confirmation: 'Bokningsbekräftelse',
  reminder: 'Påminnelse',
  bulk: 'Behandlare sjuk',
  manual_sms: 'Manuellt SMS',
  manual_email: 'Manuellt e-post',
  portal_form: 'Formulär',
};

export const DELIVERY_LABELS = {
  digital: 'digitalt (Kivra)',
  postal: 'fysiskt brev',
};
